import React from 'react'
import { ItemForm } from './ItemForm'

export const ItemNew = () => {
    return (
        <div>
            <ItemForm  ActionType="Create" />
        </div>
    )
}
